






























































import Vue from 'vue';

export default Vue.extend({
  name: 'OctInstrumentList',
  props: {
    instruments: Array
  }
});
